//import { EventManager } from './app/Globals';
import { WaitForElementToDisplay } from './app/Helpers/WaitForElementToDisplay';
import { InitDataLayer, InitState } from "./app/Services/DataLayer/DataLayerEvents";
import { SDBusiness, SDOrganization, SDWebsite, StructuredDataModelFactory } from "./app/Services/StrucuredData/index";
import './css/index.scss';
import { AjaxCheck, Logger } from "./tests/Debugger";

"use strict";

// Inject Google Analytics Datalayer
InitDataLayer();
InitState();

// Inject SEO Structured Data before app starts
let injectSD = () => {
    if (window.location.pathname === "/") {
        // for the Organization
        new StructuredDataModelFactory().AddSchema(new SDOrganization());
        // for the Business
        new StructuredDataModelFactory().AddSchema(new SDBusiness());
        // for the Website
        new StructuredDataModelFactory().AddSchema(new SDWebsite());
    }
};

if (!!(window.addEventListener)) {
    window.addEventListener("DOMContentLoaded", injectSD);
}

window.isIE11 = false;
window.isEdge = false;

if (navigator.userAgent.indexOf('MSIE') !== -1
    || navigator.appVersion.indexOf('Trident/') > -1) {
    /* Microsoft Internet Explorer 11 detected */
    window.isIE11 = true;
}

if (/Edge/.test(navigator.userAgent)) {
    /* Microsoft Edge detected */
    window.isEdge = true;
}

window.isDebug = false // allow output to console on top of logging;
window.LogFile = []; // Our debug logfile for the window session;

// Start custom console log handler
new Logger();

// Ajax Debugger //TODO: Use pure js for these so we can use it without jquery
if (!window.isIE11) {
    AjaxCheck.LogSend();
    AjaxCheck.LogError();
    AjaxCheck.LogComplete();
    //AjaxCheck.LogSuccess();
}

/* Disabled these because database is being flooded 09/18/2025 */
// Global catch-all for uncaught errors;
//Logger.ListenGlobalErrors();
//Logger.ListenUnhandledRejection();

new Promise(() => {
    console.group('Initializing Application')
    console.time('InitApp')

    new Promise<void>((resolveRoute) => {
        //Init routes
        import('./routes' /* webpackChunkName: "routes" */).then((init) => {

            init.Routes.Resolve.then(() => {

                console.info("Routes calculated");
            }).catch((err) => {
                console.error(err);
                console.log("Error routes promise chain, logfile dump: ", window.LogFile);
            });;
        }).then(() => { })

        // Resolve route promise
        resolveRoute();

    }).then(() => {
        // Init Page Load Events

        new Promise<void>((resolveInit) => {

            import('./app/Init' /* webpackChunkName: "app-init" */).then((init) => {

                //window.EventManager = new EventManager();

                new init.PageLoadEvents.Greeter();
                new init.PageLoadEvents.LinkConditioner();
                new init.PageLoadEvents.TestimonialShortener();

                // Init Event Listeners                
                init.ClickEvents.RevertImpersonation();

                console.info("Page init events loaded")

                resolveInit();

            }).then(() => {
                function bindCopySupplyList() {
                    if (window.UserMeta) { // Bind only if logged in
                        console.info("Initialize CopySupplyListVM")
                        import('./app/ViewModels/MyAccount/SpecialListVM' /* webpackChunkName: "copy-supply-list" */)
                            .then((SpecialListVM) => {
                                new SpecialListVM.CopySupplyListVM();
                                console.info("CopySupplyListVM initialized");
                            })
                            .catch(() => {
                                console.info("Initialize CopySupplyListVM failed. (It's ok.)")
                                // This block will be executed if the promise fails, 
                                // but currently it does nothing.
                            });

                    }
                }

                WaitForElementToDisplay('#page-header', 500, bindCopySupplyList);

            }).then(() => {

                import('./app/Init' /* webpackChunkName: "app-init" */).then((init) => {

                    let initDropDownSubmenu = () => { init.ClickEvents.DropdownSubmenu() };

                    WaitForElementToDisplay('#page-header', 500, initDropDownSubmenu);

                }).catch((err) => {

                    console.error(err);
                    console.log("Error in page load events promise chain, logfile dump: ", window.LogFile);
                });
            })

        }).then(() => {
            // Init Shopping Cart ViewModels
            import('./app/Cart' /* webpackChunkName: "cart-vm" */).then((viewModel) => {

                viewModel.CartVM.InitVM.then(() => {

                    const bindCartPanel = () => {
                        let cartPanel = document.getElementById('cart-header-panel');
                        ko.cleanNode(cartPanel);
                        ko.applyBindings(window.cartVM.header, cartPanel);
                        console.info("Cart Summary VM bound");
                    }

                    const bindMobileCartPanel = () => {
                        let mobileCartPanel = document.getElementById('mobile-cart-header-panel');
                        //ko.cleanNode(mobileCartPanel);
                        ko.applyBindings(window.cartVM.header, mobileCartPanel);
                        console.info("Mobile cart Summary VM bound");
                    }

                    WaitForElementToDisplay("#cart-header-panel", 500, bindCartPanel);
                    WaitForElementToDisplay("#mobile-cart-header-panel", 500, bindMobileCartPanel);

                }).catch((err) => {
                    console.error(err);
                    console.log("Error after initializing cart, logfile dump: ", window.LogFile);
                })

            }).catch((err) => {

                console.error(err);
                console.log("Error in initializing cart, logfile dump: ", window.LogFile);
            });


        }).then(() => {

            // In case it fails the first time due to errors
            $("html").css({
                'visibility': 'visible',
                'opacity': '1'
            });

            let firstRun = true;
            $(document).ajaxStop(() => {
                if (firstRun) {
                    console.info("Application loaded")
                    console.timeEnd("InitApp");
                    console.groupEnd();
                    firstRun = false;
                }
            });

        }).catch((error) => {
            console.error(error);
            console.log("Error in application init promise chain, logfile dump: ", window.LogFile);
        });

    }).then(() => {

        //setTimeout(() => { throw ("Test exception in application libs import promise chain callback"); }, 0);
        //throw ("Test exception in application libs import promise chain callback");

    }).catch((error) => {
        console.error(error);
        console.log("Error in application promise chain, logfile dump: ", window.LogFile);
    })
});